import { PaymentRequestButtonElement } from "@stripe/react-stripe-js";
import type {
  PaymentRequest,
  PaymentRequestPaymentMethodEvent,
} from "@stripe/stripe-js";
import { useContext, useEffect } from "react";
import {
  StripeContext,
  WalletTypeT,
} from "../../../../../../context/StripeContext.context";

interface WalletButtonProps {
  paymentRequest: PaymentRequest;
  walletType: Exclude<WalletTypeT, "card">;
  legalAccepted: boolean;
  translate: (key: string) => string;
}

const WalletButton = ({
  paymentRequest,
  walletType,
  legalAccepted,
  translate,
}: WalletButtonProps) => {
  const { submitWalletPayment } = useContext(StripeContext);

  useEffect(() => {
    const handler = async (ev: PaymentRequestPaymentMethodEvent) => {
      const ok = await submitWalletPayment(ev.paymentMethod.id, walletType);
      ev.complete(ok ? "success" : "fail");
    };
    paymentRequest.on("paymentmethod", handler);
    return () => {
      paymentRequest.off("paymentmethod", handler);
    };
  }, [paymentRequest, submitWalletPayment, walletType]);

  return (
    <div className="paymentV3WalletButton">
      {!legalAccepted && (
        <div className="paymentV3WalletButton__legalNotice">
          {translate("paymentV3.wallet.acceptFirst")}
        </div>
      )}
      <div
        className={
          legalAccepted
            ? "paymentV3WalletButton__inner"
            : "paymentV3WalletButton__inner paymentV3WalletButton__inner--blocked"
        }
        aria-disabled={!legalAccepted}
      >
        <PaymentRequestButtonElement
          options={{
            paymentRequest,
            style: {
              paymentRequestButton: {
                type: "default",
                theme: "dark",
                height: "48px",
              },
            },
          }}
        />
      </div>
    </div>
  );
};

export default WalletButton;
